import React from 'react';
import { Feature, ColorFrom } from '@tencent/workbench';
import { ForeColorFeature as ToolbarForeColorFeature } from '@src/framework/workbench/ui/fore-color/fore-color-feature';
import { config } from '@src/framework/workbench/ui/fore-color/config';
import { tdwDrawerReportColor } from '@framework/workbench/drawer/report';
import { ColorSelectButton } from '@framework/workbench/drawer/components/color-select-button';
import { getDrawerColorOptions, getRgbaColor } from '@framework/workbench/drawer/utils/color-options';
import { MULTI } from '@src/js/constant';
import {
    TDWVer5Type,
    TDWVer6Type,
} from '@src/slide/infrastructure/module/dependent/report/offline-data-report/constant';
import { ITDColor, TDColor } from '@src/slide/domain/ui-model/element-modeles/property/color/td-color';
import _has from 'lodash/has';
import { ActionType } from '@editor/src/js/constants/common-action-type';

const DEFAULT_COLOR = '#fefefe';

@Feature()
export class FontColorFeature extends ToolbarForeColorFeature {
    id = config.id;
    config = config;

    public constructor() {
        super();
    }

    public handleColorChange = (tdColor: ITDColor, from: ColorFrom | number) => {
        this.color = tdColor;
        this.saveRecentColorWithId(tdColor);
        this.callback(tdColor);
        this.getColorPickerManager()?.colorPickerTdwReport({
            color: tdColor.srgb_color,
            colorPickerFrom: TDWVer6Type.COLOR_PICKER_DRAWER,
            colorGroupFrom: from,
            actionType: TDWVer5Type.COLOR_PICKER_FORE_FONT,
        });
    };

    public getColorSelectButton() {
        const values = this.getMenuManager()?.toolbarMenu().values;
        const color = values?.[ActionType.FONT_THEME_COLOR];
        return <ColorSelectButton
            value={color}
            onColorChange={this.handleColorChange}
        />;
    }
}
